// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"674":"b66740ca","787":"5980d8c6"}[chunkId] + ".chunk.js";
};